import { type Guard, type GuardStatus, useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useNonCustodialBalance, useNonCustodialProviderUserWalletStatus } from '@socios-blk/core';
import { useEffect, useState } from 'react';

export const useNonCustodialGuard: Guard = () => {
	const { areSettingsLoading, settings } = useSettings();
	const [status, setStatus] = useState<GuardStatus>('loading');
	const { replace, searchParams, shallowRemoveSearchParam } = useRouter();
	const { isLoading, isNCWalletRegistered, isSmartWalletRegistered } = useNonCustodialProviderUserWalletStatus();
	const { refetch: refetchBalance } = useNonCustodialBalance({ cacheBypass: true }, { enabled: false });

	// Refetch balance when returning from the payment gateway to ensure balance data up-to-date with the chain.
	useEffect(() => {
		if (searchParams.get('source') === 'gateway') {
			refetchBalance();

			shallowRemoveSearchParam('source');
		}
	}, [searchParams, refetchBalance, shallowRemoveSearchParam]);

	useEffect(() => {
		if (isLoading || areSettingsLoading) return setStatus('loading');
		if (settings.isPoblanoEnabled && isNCWalletRegistered && isSmartWalletRegistered) return setStatus('allowed');

		return setStatus('denied');
	}, [
		isLoading,
		areSettingsLoading,
		setStatus,
		settings.isPoblanoEnabled,
		isNCWalletRegistered,
		isSmartWalletRegistered
	]);

	return {
		onDenied: () => replace('/wallet'),
		status: status
	};
};
